// Shared phone/email input rules for club-side forms. Mirrors the superadmin
// Add Club modal so validation is identical everywhere.
//
// Phone rule: local = exactly 10 digits; international = "+" then 7–14 digits.
// Email rule: standard "something@something.something".
// The isValid* helpers treat EMPTY as valid so they can be used for optional fields;
// callers enforce "required" separately.

// Strip everything except digits and a single leading "+", and physically cap the
// length while typing: "+" → up to 14 digits (international), else 10 (local).
export function sanitizePhone(value) {
  const raw = String(value ?? '');
  const hasPlus = raw.trim().startsWith('+');
  const digits = raw.replace(/\D/g, '').slice(0, hasPlus ? 14 : 10);
  return (hasPlus ? '+' : '') + digits;
}

// Valid = exactly 10 digits (local) OR "+" then 7–14 digits (international). Empty = valid.
export function isValidPhone(value) {
  const v = String(value ?? '').trim();
  if (!v) return true;
  return /^\d{10}$/.test(v) || /^\+\d{7,14}$/.test(v);
}

// Strip all whitespace as typed.
export function sanitizeEmail(value) {
  return String(value ?? '').replace(/\s/g, '');
}

// Standard email shape. Empty = valid.
export function isValidEmail(value) {
  const v = String(value ?? '').trim();
  if (!v) return true;
  return /^\S+@\S+\.\S+$/.test(v);
}

// Human hints (match wording used across the app).
export const PHONE_HINT = '10-digit number or +country format';
export const EMAIL_HINT = 'Enter a valid email';
